module.exports = __webpack_public_path__ + "static/media/icon-wechat.251ef036.svg";